import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { AiOutlineDashboard, AiOutlineUser } from "react-icons/ai";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet, useNavigate } from "react-router-dom";
import { Layout, Menu, Dropdown, Drawer, Button } from "antd";
import { removeUserInfo } from "../features/auth/authSlice";
import profileLogo from "../assests/images/user.png";
import { FaBell } from "react-icons/fa";
import { Badge } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setNewOrdersCount } from "../features/auth/notificationSlice";
import { clearNewOrders } from "../features/auth/notificationSlice";

const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const newOrdersCount = useSelector((state) => state.notification.newOrdersCount);

  // const [newOrdersCount, setNewOrdersCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Remove this line:

  const handleMenuClick = ({ key }) => {
    if (key === "signout") {
      localStorage.clear();
      dispatch(removeUserInfo());
      navigate("/login");
    } else {
      navigate(key);
    }
  };

  const sideMenuItems = [
    {
      key: "",
      icon: <AiOutlineDashboard className="text-lg" />,
      label: "Dashboard",
    },
    {
      key: "Catalog",
      icon: <AiOutlineUser className="text-lg" />,
      label: "Pages",
      children: [
        { key: "orders", label: "Orders" },
        { key: "customers", label: "User" },
        { key: "employees", label: "Employees" },
        { key: "ManageServices", label: "Manage Services" },
        { key: "revenue", label: "Revenue" },
      ],
    },
  ];

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="signout">Sign Out</Menu.Item>
    </Menu>
  );
  useEffect(() => {
    const fetchNewOrdersCount = async () => {
      // Replace this with real API call
      const count = 3;
      dispatch(setNewOrdersCount(count));
    };
    fetchNewOrdersCount();
  }, [dispatch]);

  return (
    <Layout className="min-h-screen bg-gray-100">
      {/* SIDER for Desktop */}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        className="hidden md:block"
        width={240}
        style={{
          background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
        }}
      >
        <div className="logo py-4 text-center text-white text-xl font-bold border-b border-blue-700">
          {collapsed ? "HS" : "Home Service"}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={handleMenuClick}
          items={sideMenuItems}
          className="mt-4 text-sm"
          style={{
            background: "transparent",
          }}
        />
      </Sider>

      {/* Drawer for Mobile */}
      <Drawer
        placement="left"
        onClose={() => setDrawerVisible(false)}
        visible={drawerVisible}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={(info) => {
            setDrawerVisible(false);
            handleMenuClick(info);
          }}
          items={sideMenuItems}
        />
      </Drawer>

      <Layout>
        <Header className="bg-white hover:bg-blue-300 shadow flex items-center justify-between px-4 py-2 sticky top-0 z-50">
          <div className="flex items-center gap-4">

            <Button
              type="text"
              icon={
                collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
              }
              className="hidden md:inline-block"
              onClick={() => setCollapsed(!collapsed)}
            />
            <Button
              type="text"
              icon={<MenuUnfoldOutlined />}
              className="md:hidden"
              onClick={() => setDrawerVisible(true)}
            />
            <div>
              <h2 className="text-lg font-semibold">Admin Dashboard</h2>
              <p className="text-xs text-gray-500">Manage your services</p>
            </div>
          </div>
          <Badge count={newOrdersCount} overflowCount={99} size="small">
            <FaBell
              style={{
                fontSize: "22px",
                color: "#fadb14",
                cursor: "pointer",
              }}
              title="New Orders"
              onClick={() => {
                dispatch(clearNewOrders());
                navigate("orders");
              }}

            />
          </Badge>
          <Dropdown overlay={menu} trigger={["click"]}>
            <div className="flex items-center cursor-pointer hover:text-white p-2 rounded transition">
              <img
                src={profileLogo}
                alt="avatar"
                className="w-10 h-10 rounded-full border"
              />
              <div className="ml-2 hidden sm:block">
                <p className="text-sm text-gray-600">Admin</p>
                <p className="text-xs text-gray-400 hover:text-white ">admin@gmail.com</p>
              </div>
            </div>
          </Dropdown>

        </Header>

        <Content className="m-4 p-4 rounded-lg bg-white shadow">
          <ToastContainer
            position="top-right"
            autoClose={300}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
